export enum BlockType {
  timed = 'timed',
  tutor = 'tutor',
}

export enum BlockTimeSetting {
  default = 'default',
  quarter = 'quarter',
  half = 'half',
  double = 'double',
}

export interface SchedulingRequestBody {
  due: Date | string;
  stability: number;
  difficulty: number;
  elapsedDays: number;
  scheduledDays: number;
  reps: number;
  lapses: number;
  state: number;
  lastReview: Date | string;
  sessionId?: string;
}

export interface StudySession {
  id: string;
  date: string;
  flashcardCount: number;
  completedFlashcardCount: number;
  vignetteCount: number;
  blockCount: number;
  isComplete: boolean;
  isStarted: boolean;
  activeBlockId: string;
  vignetteCorrectCount: number;
  vignetteIncorrectCount: number;
  vignetteOmittedCount: number;
  isReview: boolean;
  isSnoozed: boolean;
  hasSeenPriorities: boolean;
  isUsingFlashcards: boolean;
  isUsingQbank: boolean;
  isFirstSession: boolean;
  userId: string;
}

export interface StudySessionWithExam extends StudySession {
  exam: {
    name: string;
  };
  examId: string;
  isDemo: boolean;
  phase: string;
  userId: string;
}

export interface BlockAnswers {
  [key: string]: {
    answer: string;
    correctAnswer: string;
    submitted: boolean;
    vignetteContentId: string;
    secondAnswer?: string;
    secondSubmitted?: boolean;
  };
}
// Generic key-value mapping type for block data
export type BlockKeyValueMap<T> = {
  [key: string]: T;
};

export interface Block {
  id: string;
  type: BlockType;
  answers: BlockAnswers;
  // Combined similar key-value interfaces into single type
  flags: BlockKeyValueMap<boolean>;
  notes: BlockKeyValueMap<string>;
  answerCrossouts: BlockKeyValueMap<boolean[]>;
  questionHighlights: BlockKeyValueMap<string>;
  date: Date;
  duration: number;
  isStarted: boolean;
  isSubmitted: boolean;
  correctCount: number;
  incorrectCount: number;
  omittedCount: number;
  vignetteCount: number;
  timeSetting: string;
  ord?: number;
  isRecalculated?: boolean;
}

export enum StartType {
  Home = 'Home',
}

export interface StudySessionWithBlocks {
  id: string;
  date: string;
  flashcardCount: number;
  completedFlashcardCount: number;
  vignetteCount: number;
  blockCount: number;
  isComplete: boolean;
  isStarted: boolean;
  activeBlockId: string;
  vignetteCorrectCount: number;
  vignetteIncorrectCount: number;
  vignetteOmittedCount: number;
  isReview: boolean;
  isSnoozed: boolean;
  hasSeenPriorities: boolean;
  isUsingFlashcards: boolean;
  isUsingQbank: boolean;
  blocks: Block[];
}

export enum PanelType {
  explanation = 'explanation',
  library = 'library',
  report = 'report',
  flashcards = 'flashcards',
  chat = 'chat',
}
